import React from "react";
import TabSelector from "globalComponents/TabSelector/TabSelector";
import CheckIcon from "icons/CheckIcon";
import ClockIcon from "icons/ClockIcon";
import CalendarIcon from "icons/CalendarIcon";

export default function TypeSelector({ itemType, setItemType }) {
  const types = ["task", "appointment", "calendar_note"];
  const taskIcon = <CheckIcon />;
  const apptIcon = <ClockIcon />;
  const calNoteIcon = <CalendarIcon />;
  const optionContents = [taskIcon, apptIcon, calNoteIcon];

  return (
    <div className="type-selector-container">
      <TabSelector
        optionContents={optionContents}
        shape="square"
        options={types}
        selectedOption={itemType}
        setSelectedOption={setItemType}
      />
    </div>
  );
}
